'use client';

export interface BackdropTheme {
  baseColor: string;
}

export const DEFAULT_BACKDROP_THEME: BackdropTheme = {
  // ChatGPT's black (owner, 2026-09-28: 'make it full black'), no starfield on top.
  baseColor: '#000000',
};
